import { jsx as i } from "react/jsx-runtime";
import { useBreakpointMatch as s } from "../../../utils/use-breakpoint-match.js";
import { RocheUITabs as n } from "../../tabs/roche-tabs.js";
import { RocheUIPipelineLaneHeader as h } from "../pipeline-lane-header/roche-pipeline-lane-header.js";
import { RocheUIPipelineLaneRow as c } from "../pipeline-lane-row/roche-pipeline-lane-row.js";
import { PIPELINE_MOBILE_BREAKPOINT as b } from "../pipeline-lanes.js";
import l from "./roche-pipeline-header.module.scss.js";
const N = ({
  lanes: r,
  itemCountTextByLaneId: t,
  onLaneSelect: o
}) => {
  const m = s(b), p = () => /* @__PURE__ */ i(
    n,
    {
      appearance: "light",
      tabs: r.map((e) => ({ id: e.id, headline: e.label })),
      onTabClick: (e, I, d) => o == null ? void 0 : o(d)
    }
  ), a = () => /* @__PURE__ */ i(c, { laneCount: r.length, children: r.map((e) => /* @__PURE__ */ i(h, { lane: e, itemCountText: t[e.id] ?? "" }, e.id)) });
  return /* @__PURE__ */ i("div", { className: l["pipeline-header"], children: m ? p() : a() });
};
export {
  N as RocheUIPipelineHeader
};
